module.exports = __webpack_public_path__ + "img/star_logo.fb8c37b7.png";